import React from 'react'
import { Skeleton } from '@material-ui/lab'

const LoadingsSideBar: React.FC = () => {
  return (
    <div style={{ height: '285px', width: '100%' }}>
      <Skeleton variant="text" width="80%" height="32px" />
      <Skeleton variant="text" width="80%" height="32px" />
      <Skeleton variant="text" width="50%" height="24px" style={{ marginTop: 8 }} />
      <Skeleton variant="text" width="80%" height="48px" style={{ marginTop: 8 }} />
      <Skeleton variant="text" width="60%" height="20px" style={{ marginTop: 8 }} />
      <Skeleton variant="text" width="70%" height="24px" style={{ marginTop: 16 }} />
      <Skeleton variant="text" width="60%" height="20px" style={{ marginTop: 8 }} />
    </div>
  )
}

export default LoadingsSideBar
